import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetProfileRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetProfileResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getProfile = (request: GetProfileRequest, options?: CashRequestOptions) =>
  post<GetProfileRequest, GetProfileResponse>('/2.0/cash/get-profile', request, { ...options, rejectOnError: true })
